export default __webpack_public_path__ + "static/QuercusGroupLogo-5321e2b23b5da9e5366fd9a212f813c2.svg";